"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spinner = _interopRequireDefault(require("../spinner"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _ssoDeck = require("../sso-deck");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */
/* eslint-disable complexity */

const IframeContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IframeContainer",
  class: "pl-i1l9p98u",
  vars: {
    "i1l9p98u-0": [({
      isLoading
    }) => isLoading ? 'none' : 'block']
  }
});
const SSODECK_EVENT = {
  ON_LOAD: 'on_load',
  ON_RESIZE: 'on_resize',
  ON_AUTH: 'on_auth',
  ON_ERROR: 'on_error',
  REDIRECT: 'redirect',
  FRAUD: 'fraud',
  ON_TRAFFIC: 'on_traffic'
};
const SSODECK_HANDSHAKE_REQUEST = 'ssodeck_handshake_request';

/**
 * Create Encoded Path and Lid query combination
 *
 * @param {string} path Path
 * @param {string} lid Lid
 * @returns {string} Encoded Path and Lid
 */
function createPath(path, lid) {
  const decodedPath = decodeURIComponent(path);
  const decodedLid = decodeURIComponent(lid);
  let url;
  if (typeof window !== 'undefined') {
    const currentURL = new URL(window.location.href);
    url = new URL(decodedPath, currentURL);
    url.searchParams.set('lid', decodedLid);
  } else {
    url = decodedPath;
  }
  return url.toString();
}
const createUrl = (app, path, host) => {
  if (!app || !host) {
    throw new Error('App and host must be defined.');
  }
  const sanitizedPath = path ? encodeURI(path) : '';
  const protocol = typeof window !== 'undefined' && window.location ? window.location.protocol : 'https:';
  let redirectUrlString;
  if (typeof URL !== 'undefined') {
    const redirectUrl = new URL(`${protocol}//${app}.${host}${sanitizedPath}`);
    redirectUrlString = redirectUrl.toString();
  } else {
    redirectUrlString = `${protocol}//${app}.${host}${sanitizedPath}`;
  }
  return redirectUrlString;
};
function SsoIframe({
  id,
  _name,
  app = 'www',
  path = '/',
  lid = '',
  port = '443',
  realm = 'idp',
  host = 'godaddy.com',
  pageToLoad = '/landing',
  pageTitles,
  pageToLoadData = {}
}) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const handshakeRequestorIntervalId = (0, _react.useRef)(null);
  const ssoIframeElem = (0, _react.useRef)(null);
  const envHost = (0, _react.useMemo)(() => (0, _ssoDeck.getHostEnv)(host), [host]);
  const baseUrl = createUrl('sso', '', envHost);
  const redirectUrl = createUrl(app, path, envHost);
  const fullPath = lid ? createPath(path, lid) : path;
  let fullSrc = null;
  if (typeof window !== 'undefined' && envHost && pageToLoad) {
    try {
      fullSrc = new URL(pageToLoad, baseUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Invalid URL:', error);
    }
  }
  if (fullSrc && typeof window !== 'undefined') {
    app?.length !== 0 && fullSrc.searchParams.set('app', app);
    fullSrc.searchParams.set('path', fullPath);
    port?.length !== 0 && fullSrc.searchParams.set('port', port);
    realm?.length !== 0 && fullSrc.searchParams.set('realm', realm);
    lid?.length !== 0 && fullSrc.searchParams.set('lid', lid);
    fullSrc.searchParams.set('iframe', 'true');
    fullSrc.searchParams.set('firstaccess', 'true');
  }
  const sendTrafficEvents = eventId => {
    (0, _patternLibraryUtils.logImpression)(eventId);
  };
  function handleFraud(formHtml, submissionId) {
    if (typeof document !== 'undefined') {
      const formDiv = document.createElement('div');
      formDiv.style.display = 'none';
      formDiv.innerHTML = formHtml;
      document.body.appendChild(formDiv);
      document.getElementById(submissionId).submit();
    }
  }
  const stopInitializer = () => {
    if (handshakeRequestorIntervalId.current) {
      clearInterval(handshakeRequestorIntervalId.current);
      handshakeRequestorIntervalId.current = null;
    }
  };
  const receiveMessage = event => {
    if (event.origin !== window.origin.replace('www', 'sso')) return new Error(`Event origin does not match ${event.origin} ${window.origin}`);
    try {
      switch (event.data.action) {
        case SSODECK_EVENT.ON_LOAD:
          stopInitializer();
          break;
        case SSODECK_EVENT.ON_RESIZE:
          ssoIframeElem.current.height = event.data.size.height;
          break;
        case SSODECK_EVENT.ON_AUTH:
          if (typeof window !== 'undefined' && redirectUrl) {
            window.location = redirectUrl;
          }
          break;
        case SSODECK_EVENT.REDIRECT:
          window.location = event.data.redirect_url;
          break;
        case SSODECK_EVENT.FRAUD:
          handleFraud(event.data.form_html, event.data.submission_id);
          break;
        case SSODECK_EVENT.ON_TRAFFIC:
          if (event.data.data.event_id) {
            sendTrafficEvents(event.data.data.event_id);
          }
          break;
        default:
          break;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const postMessageToIframe = message => {
    if (ssoIframeElem?.current?.contentWindow) {
      ssoIframeElem.current.contentWindow.postMessage(message, baseUrl);
    }
  };
  const startInitializer = () => {
    stopInitializer();
    handshakeRequestorIntervalId.current = setInterval(() => {
      postMessageToIframe({
        action: SSODECK_HANDSHAKE_REQUEST,
        host_traffic_func: true,
        page_titles: pageTitles,
        page_to_load_data: pageToLoadData
      });
    }, 75);
  };
  (0, _react.useEffect)(() => {
    if (ssoIframeElem.current) {
      window.addEventListener('message', receiveMessage, false);
    }
    return () => {
      window.removeEventListener('message', receiveMessage, false);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (ssoIframeElem.current) {
      ssoIframeElem.current.onload = function () {
        startInitializer();
        setIsLoading(false);
      };
    }
  }, []);
  _patternLibraryUtils.tracking.useTracking(ssoIframeElem);
  const trackingProps = _patternLibraryUtils.tracking.props(_name);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg"
  }), /*#__PURE__*/_react.default.createElement(IframeContainer, {
    "data-cy": "iframe-container",
    isLoading: isLoading
  }, fullSrc && /*#__PURE__*/_react.default.createElement("iframe", (0, _extends2.default)({
    id: `id-${id}`,
    title: "Old Sso Widget",
    className: "sso-widget",
    "data-cy": "iframe-widget",
    src: fullSrc.toString(),
    ref: ssoIframeElem
  }, trackingProps))));
}
var _default = exports.default = SsoIframe;
SsoIframe.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  app: _propTypes.default.string,
  path: _propTypes.default.string,
  lid: _propTypes.default.string,
  port: _propTypes.default.string,
  realm: _propTypes.default.string,
  host: _propTypes.default.string,
  pageToLoad: _propTypes.default.string,
  pageTitles: _propTypes.default.object,
  pageToLoadData: _propTypes.default.shape({
    hide_social: _propTypes.default.bool
  }),
  onAuth: _propTypes.default.func
};